import { Task } from "../models/Task";
import { SwivuConnectedStoreMixin } from "./mixins/SwivuConnectedStoreMixin";
import { SwivuSortedGroupersMixin } from "./mixins/SwivuSortedGroupersMixin";
import { SwivuStoreArchiveMixin } from "./mixins/SwivuStoreArchiveMixin";
import { Store } from "@bryntum/schedulerpro";
import {STORE_KEYS} from "../../other/constants/StoreKeys.jsx";

export class SwivuTaskStore extends SwivuConnectedStoreMixin(SwivuSortedGroupersMixin(SwivuStoreArchiveMixin(Store))) {
  static get $name() {
    return "SwivuTaskStore";
  }

  static get configurable() {
    return {
      id: STORE_KEYS.taskStore,
      storeId: STORE_KEYS.taskStore,
      modelClass: Task,
    };
  }

  construct(config) {
    super.construct(config);
  }
}
